import { jsx } from 'react/jsx-runtime';
import '../../../utils/index_orig/index.esm.js';
import '../../../utils/theme/theme-provider/index.esm.js';
import { getLocaleDateString } from '../../../calendar/generic-utils/dateUtils/index.esm.js';
import '../../../calendar/CalendarBase/calendar/index.esm.js';
import '../../../calendar/CalendarNavigation/calendar-navigation-pagination/index.esm.js';
import '../../../calendar/CalendarNavigation/calendar-navigation-scrolling/index.esm.js';
import '../../../styles/uitk-egds-calendar.css';
import '../../../calendar/DayTemplateToolkit/ToolkitComponents/date-number/index.esm.js';
import '../../../calendar/DayTemplateToolkit/ToolkitComponents/availability-background/index.esm.js';
import '../../../calendar/DayTemplateToolkit/ToolkitComponents/EventBar/event-bar/index.esm.js';
import '../../../calendar/DayTemplateToolkit/ToolkitComponents/EventBar/bar-style/index.esm.js';
import '../../../calendar/DayTemplateToolkit/ToolkitComponents/Legend/legend-swatches/index.esm.js';
import '../../../calendar/types/index.esm.js';
import styles from '../../../styles/uitk-egds-date-selector.css';
import { classNames } from '../../../utils/classnames/index.esm.js';
const getClassNameList = classNames.bind(styles);
const dateDisplayClassName = 'uitk-date-display';
const EGDSDateDisplay = props => {
  const {
    id,
    locale = 'en-US',
    label = 'Date',
    date,
    isActive = false,
    isFullSize = false,
    dateFormatOptions = {
      month: 'short',
      day: 'numeric',
      weekday: 'short'
    },
    onDateDisplayClick
  } = props;
  const value = date ? getLocaleDateString(date, locale, dateFormatOptions) : label;
  const selectionButtonClasses = getClassNameList(dateDisplayClassName, {
    'selection-filled': date,
    selected: isActive,
    'full-size': isFullSize
  });
  return jsx("button", {
    type: "button",
    "aria-pressed": isActive,
    id: id,
    className: selectionButtonClasses,
    onClick: onDateDisplayClick,
    children: jsx("span", {
      className: `${dateDisplayClassName}-value`,
      children: value
    })
  });
};
export { EGDSDateDisplay };